import { BoxSettings, Categories } from '../../api/graphql/master/types';
import { SubscriptionLineApiType } from '../../types/api/SubscriptionApiType';
import { toProductGid } from './utils';

export function getAllProductIds(
  lines: SubscriptionLineApiType[],
  cats: Categories,
  box: BoxSettings
) {
  const productIds = new Set<string>();

  for (let i = 0; i < lines.length; i++) {
    const productId = lines[i].productId;
    if (!productId) continue;
    productIds.add(productId);
  }

  for (const key in cats) {
    const list = cats[key].productList;
    if (!list) continue;

    for (let i = 0; i < list.length; i++) {
      const productId = list[i].productId;
      if (!productId) continue;

      productIds.add(toProductGid(productId));
    }
  }

  for (const key in box) {
    const list = box[key].boxes;
    const boxProductId = box[key].productId;
    if (!list || !boxProductId) continue;
    productIds.add(toProductGid(boxProductId));

    for (let i = 0; i < list.length; i++) {
      const productId = list[i].productId;
      if (!productId) continue;

      productIds.add(toProductGid(productId));
    }
  }

  return productIds;
}

export function getCategoriesProductIds(cats: Categories) {
  const ids: Record<string, boolean> = {};

  for (const key in cats) {
    const list = cats[key].productList;
    if (!list) continue;

    for (let i = 0; i < list.length; i++) {
      const productId = list[i].productId;
      if (!productId) continue;

      ids[productId] = true;
    }
  }

  return ids;
}
